export default __webpack_public_path__ + "static/media/ScreenShot_3.3468dce1.jpg";